import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useState } from 'react';

export interface ConfirmationDialogProps {
    onClose: () => void;
    onConfirm: () => void;
    typeValueToConfirm?: string;
    isOpen: boolean;
    message: React.ReactNode;
    title: string;
    confirmText?: string;
}

export default function ConfirmationDialog({
    onClose,
    onConfirm,
    typeValueToConfirm,
    isOpen,
    message,
    title,
    confirmText = 'Confirm',
}: ConfirmationDialogProps) {
    const [confirmEnabled, setConfirmEnabled] = useState(!typeValueToConfirm);
    const [inputValue, setInputValue] = useState('');

    return (
        <div id="portal-site">
            <Dialog
                onClose={onClose}
                aria-labelledby="confirm-dialog"
                open={isOpen}
                PaperProps={{sx: { minWidth: '500px' }}}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="confirm-dialog">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {!typeValueToConfirm ? <Typography gutterBottom>{message}</Typography> : <Alert severity="warning" sx={{marginBottom: 2}}>{message}</Alert>}
                    {typeValueToConfirm && (
                        <TextField
                            autoFocus
                            required
                            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                                const { value } = evt.target;

                                setInputValue(value);

                                if (value && value.toLowerCase().trim() === typeValueToConfirm.toLowerCase()) {
                                    setConfirmEnabled(true);
                                } else if (confirmEnabled) {
                                    setConfirmEnabled(false);
                                }
                            }}
                            variant="outlined"
                            fullWidth
                            value={inputValue}
                        />
                    )}
                </DialogContent>
                <DialogActions sx={{padding: 2}}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            color: 'text.primary',
                            borderColor: 'text.primary',
                            '&:hover':{ borderColor:'text.primary' }
                        }}
                    >
                        cancel
                    </Button>
                    <Button
                        variant="contained"
                        autoFocus={confirmEnabled}
                        disabled={!confirmEnabled}
                        onClick={onConfirm}
                        sx={{
                            color: '#fff',
                            borderColor: 'text.primary',
                            bgcolor: 'text.primary',
                            '&:hover':{ bgcolor:'text.primary' }
                        }}
                    >{confirmText}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
